import type { AnswerGroupOption } from "@/shared/models/legacy-types";
import { Checkbox } from "@/shared/ui";
import { tw } from "@/shared/utils";

interface AnswerCheckboxGroupProps<TValue> {
  id: string;
  options: readonly AnswerGroupOption<TValue>[];
  value?: TValue[];
  className?: string;
  onChange: (value: TValue[]) => void;
}

export const AnswerCheckboxGroup = <TValue extends string | number>({
  id,
  options,
  value = [],
  className,
  onChange,
}: AnswerCheckboxGroupProps<TValue>) => {
  return (
    <div id={id} className={tw("grid gap-3", className)}>
      {options.map((option, _, array) => (
        <div
          key={option.value}
          className={tw(
            "flex flex-col gap-3",
            option.unique && "col-span-full",
          )}
        >
          <Checkbox.Item
            value={option.value}
            checked={value.includes(option.value)}
            onCheckedChange={(checked) => {
              const hasUniqueOption =
                value.length === 1 &&
                options.find((option) => option.value === value[0])?.unique;
              if ((checked && !!option.unique) || hasUniqueOption) {
                return onChange([option.value]);
              }

              return checked
                ? onChange([...value, option.value])
                : onChange(value.filter((value) => value !== option.value));
            }}
            isCard
            className="w-full grow"
          >
            <Checkbox.Label className={tw(option.unique && "font-semibold")}>
              {option.label}
            </Checkbox.Label>
          </Checkbox.Item>

          {option.unique &&
            array
              .filter((option) => !option.unique)
              .every((option) => option.disqualifier) && (
              <hr className="my-3 bg-neutral-200" />
            )}
        </div>
      ))}
    </div>
  );
};
